import React, { useEffect } from 'react';
import { useSnowflakeContext } from './contexts/SnowflakeContext';
import { getTableLabel } from '../utils/data-warehouse';
import { deleteIntegrationAndLaunchPopUp } from '../utils';
import Fields_mapping from '../fields_mapping';
import { isPasswordCredentials } from './types';

export function SnowflakeOverview() {
  const {
    tenant,
    credentials,
    setEditMode,
    clearCredentials,
  } = useSnowflakeContext();

  useEffect(() => {
    const backboneComponent = new Fields_mapping({
      tenant,
      integration: 'snowflake',
      credentialsFound: true,
    });
    const target = document.getElementById('fields_mapping');
    if (target) backboneComponent.setElement(target);
  }, []);

  const handleEditClick = () => {
    setEditMode(true);
  };

  const handleDeleteClick = async () => {
    await deleteIntegrationAndLaunchPopUp(tenant, 'snowflake', () => {
      clearCredentials();
    });
  };

  return (
    <>
      <div className="row justify-content-center mt-4">
        <div className="col-8">
          <div className="card box-shadow-3d mb-3">
            <div className="card-header">
              <div className="d-flex align-items-center">
                <img
                  className="con-map-mk-integration-logo-size"
                  style={{ width: '30px' }}
                  src="/media/integrations/logos/snowflake-icon.png"
                />
                <h5 className="mb-0 ml-3">Snowflake</h5>
              </div>
            </div>
            <div className="card-body">
              <p>Snowflake has been configured!</p>
              <h5>Credentials</h5>
              <div className="row">
                <div className="col-md-2">Account:</div>
                <div className="col-md-10">{credentials?.account}</div>
              </div>
              <div className="row">
                <div className="col-md-2">Username:</div>
                <div className="col-md-10">{credentials?.username}</div>
              </div>
              {isPasswordCredentials(credentials) ? (
                <div className="row">
                  <div className="col-md-2">Password:</div>
                  <div className="col-md-10">********</div>
                </div>
              ) : credentials?.authMethod === 'keyPair' ? (
                <div className="row">
                  <div className="col-md-2">Authentication Method:</div>
                  <div className="col-md-10">Key Pair</div>
                </div>
              ) : (
                <div className="row">
                  <div className="col-md-2">Authentication:</div>
                  <div className="col-md-10">Details not available</div>
                </div>
              )}
              <div className="row">
                <div className="col-md-2">Database:</div>
                <div className="col-md-10">{credentials?.database}</div>
              </div>
              <div className="row">
                <div className="col-md-2">Schema:</div>
                <div className="col-md-10">{credentials?.schema}</div>
              </div>
              <h5 className="mt-2">Mapping</h5>
              {(['event', 'contact_update', 'account_update'] as const).map(
                (table) => {
                  const theirTable = credentials?.tableNames?.[table];

                  if (!theirTable) return null;

                  return (
                    <div key={table} className="mb-2">
                      <div className="row">
                        <div className="col-md-4 font-weight-bold">
                          {getTableLabel(table)}:
                        </div>
                        <div className="col-md-8 font-weight-bold">
                          {theirTable}
                        </div>
                      </div>
                      {Object.entries(
                        credentials?.columnNames?.[table] ?? {}
                      ).map(([key, value]) => {
                        return (
                          <div key={key} className="row">
                            <div className="col-md-4">{key}:</div>
                            <div className="col-md-8">{value}</div>
                          </div>
                        );
                      })}
                    </div>
                  );
                }
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3 pb-4 text-center">
        <button className="btn btn-primary" onClick={handleEditClick}>
          Edit
        </button>

        <button className="btn btn-danger ml-2" onClick={handleDeleteClick}>
          Delete
        </button>
      </div>

      <div id="fields_mapping" />
    </>
  );
}
